import React from 'react';

import { MyFundsRequests } from 'features/funds-request';

export const TraderArchiveFundsRequests: React.FC = () => <MyFundsRequests />;
